import { Component, HostListener, Input } from '@angular/core';
import { DeleteModal } from '../models/delete-modal';

@Component({
    selector: "deletemodal",
    templateUrl: "../templates/template1/views/delete.component.html",
    styleUrls: ["./../../shared/templates/default/themes/default/CSS/admin.css"]
})
export class DeleteComponent {

    @Input() deleteModal: DeleteModal;

    constructor() { }

    noClick() {
        this.deleteModal.toggle = false;
        this.deleteModal.callbackNo();
    }

    yesClick() {
        this.deleteModal.toggle = false;
        this.deleteModal.callbackYes();
    }

     okClick() {
        this.deleteModal.toggle = false;
        this.deleteModal.callBackOk();
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        const ESCAPE_KEYCODE = 27
        if (event.keyCode === ESCAPE_KEYCODE) {
            if(!this.deleteModal.viewActionButtons){
                this.okClick();
            }
            else{
                this.noClick();
            }
        }
    }
   
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/delete.component.ts